import axios from 'axios';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Spinner} from "react-bootstrap";
import ModalComponent from "../ModalComponent";

class LoginAsSAdminComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            email: this.props.email,
            password: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
        };
    }

    componentDidMount() {
        // this.setState({
        //     isLoading: true
        // });
        window.scrollTo(0, 0);
        this.showModal();
    }

    showModal = () => {
        let titleModal = 'Thiết lập bảo mật';
        let modalBody = this.modalBody();
        this.setState({
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            alert: {
                error: false,
                message: ''
            },
        })
    }

    modalBody = () => {
        return (
            <>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" className="form-control" value={ this.state.email } disabled={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Mật khẩu</label>
                    <input type="password" name="password" className="form-control"
                           defaultValue={ this.state.password }
                           onChange={ this.changeInput }
                    />
                </div>
            </>
        )
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        // console.log(name, value)
        this.setState({
            [name]: value
        });
    }

    hiddenModal = () => {
        window.close();
    }

    confirmModal = () => {
        // console.log("da den 2")
        // this.setState({
        //     isLoading: true
        // });
        if ( this.state.password.length ) {
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                email: this.props.email,
                password: this.state.password
            };

            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            // console.log(form)
            axios.post( process.env.REACT_APP_API_URL + '/api/checkLoginFromSa', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
                        'dataAgency' : JSON.stringify(dataAuth),
                        'Authorization' : this.props.token,
                    }
                }
            )
                .then( async (ref) =>  {
                    // console.log(ref.data.error)
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            isSpinner: false,
                        });

                        let itemLogin = {
                            token: ref.data.token
                        }
                        this.props.login(itemLogin);
                        let menu = 'user';
                        let sessionRole = 'user';
                        if ( ref.data.user.role === 'admin' || ref.data.user.role === 'super_admin' ) {
                            menu = 'cloudzoneAdmin-admin-menuAdmin';
                            sessionRole = 'cloudzoneAdmin-admin-admin';

                            let itemAgency = {
                                agency_credit: ref.data.timeC
                            }
                            await this.props.updateAgencyCredit(itemAgency);
                        }

                        let itemUser = {
                            user: ref.data.user,
                            menu: menu,
                            sessionRole: sessionRole,
                            credit: ref.data.credit,
                        }

                        await this.props.saveUser(itemUser);

                        await this.setState({
                            isLoading: false
                        });

                        await this.props.redirectHome();
                    } else {
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }

                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(1, "Đăng nhập thất bại"),
                            title: this.state.contentModal.title
                        },
                    })
                })
        }
        else {
            this.setState({
                contentModal: {
                    modalBody: this.modalBodyConfirm(1, "Vui lòng nhập mật khẩu để đăng nhập"),
                    title: this.state.contentModal.title
                },
            })
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        config: state.configSystem.config,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        remember: (item) => {
            dispatch(({ type : 'remember', item }))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateSystem: (item) => {
            dispatch(({ type : 'updateSystem', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
        updateAgencyCredit: (item) => {
            dispatch(({ type : 'updateAgencyCredit', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginAsSAdminComponent);